export interface Jobs {
  id: string;
  location: string;
  title: string;
  datePosted: Date;
  department: string;
}

export const sampleLocations: string[] = [
  "All Locations",
  "Abuja",
  "Lagos",
  "Ogun",
  "Rivers",
];
export const sampleDepartments: string[] = [
  "All Departments",
  "Data Analytics",
  "Engineering",
  "Product Engineering",
  "Sales",
];

export const sampleJobs: Jobs[] = [
  {
    id: "001",
    location: "Lagos",
    title: "Senior iOS Developer",
    datePosted: new Date(),
    department: "Engineering",
  },
  {
    id: "002",
    location: "Lagos",
    title: "UX Designer",
    datePosted: new Date(),
    department: "Product Engineering",
  },
  {
    id: "003",
    location: "Rivers",
    title: "Senior Full Stack Developer",
    datePosted: new Date(),
    department: "Engineering",
  },
  {
    id: "004",
    location: "Rivers",
    title: "Android Developer",
    datePosted: new Date(),
    department: "Engineering",
  },
  {
    id: "005",
    location: "Rivers",
    title: "UX Writer",
    datePosted: new Date(),
    department: "Product Engineering",
  },
  {
    id: "006",
    location: "Ogun",
    title: "Visual Designer",
    datePosted: new Date(),
    department: "Product Engineering",
  },
  {
    id: "007",
    location: "Rivers",
    title: "Data Scientist",
    datePosted: new Date(),
    department: "Data Analytics",
  },
  {
    id: "008",
    location: "Rivers",
    title: "BI Developer",
    datePosted: new Date(),
    department: "Data Analytics",
  },
  {
    id: "009",
    location: "Abuja",
    title: "Senior iOS Developer",
    datePosted: new Date(),
    department: "Data Analytics",
  },
  {
    id: "010",
    location: "Lagos",
    title: "Regional Sales Analyst",
    datePosted: new Date(),
    department: "Sales",
  },
  {
    id: "011",
    location: "Abuja",
    title: "Customer Relationship Officer",
    datePosted: new Date(),
    department: "Sales",
  },
];
